import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	viewAllAppsLabel: {
		id: 'navigation.global-shortcuts.view-all-apps.label',
		description: 'Button in Global App Shortcuts linking to a page to view all available apps',
		defaultMessage: 'View all apps',
	},
});
